import React from "react";

const EmployeeGuideDocuments = () => {
  return <div>EmployeeGuideDocuments</div>;
};

export default EmployeeGuideDocuments;
